module.exports = [
	{
		"line": "6",
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && spout-design_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "7",
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && spout-design_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"30339DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "8",
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && spout-design_opt1 && finish_opt0 && boiler-size_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "9",
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && spout-design_opt1 && finish_opt2"
		],
		"groups": [
			{
				"products": [
					"30085AL1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "10",
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && spout-design_opt1 && finish_opt1 && boiler-size_opt0"
		],
		"groups": [
			{
				"products": [
					"30085DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "11",
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && spout-design_opt1 && finish_opt3"
		],
		"groups": [
			{
				"products": [
					"30085DL1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "12",
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && spout-design_opt1 && finish_opt0 && boiler-size_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "13",
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && spout-design_opt1 && finish_opt1 && boiler-size_opt1"
		],
		"groups": [
			{
				"products": [
					"30080DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "14",
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && spout-design_opt0 && finish_opt1 && boiler-size_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "15",
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && spout-design_opt0 && finish_opt2"
		],
		"groups": [
			{
				"products": [
					"30327AL1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "16",
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && spout-design_opt0 && finish_opt3"
		],
		"groups": [
			{
				"products": [
					"30327DL1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "17",
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && spout-design_opt0 && finish_opt1 && boiler-size_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "18",
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && spout-design_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"30325001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "19",
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && spout-design_opt0 && finish_opt1 && boiler-size_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "20",
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && spout-design_opt1 && finish_opt0 && boiler-size_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "21",
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && spout-design_opt1 && finish_opt2"
		],
		"groups": [
			{
				"products": [
					"30083AL1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "22",
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && spout-design_opt1 && finish_opt1 && boiler-size_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "23",
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && spout-design_opt1 && finish_opt0 && boiler-size_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "24",
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && spout-design_opt1 && finish_opt1 && boiler-size_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "25",
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "26",
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "27",
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && finish_opt3"
		],
		"groups": [
			{
				"products": [
					"31498DL1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "28",
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && finish_opt2"
		],
		"groups": [
			{
				"products": [
					"31498AL1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "29",
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && spout-design_opt0 && pull-out_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31539000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "30",
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && spout-design_opt0 && pull-out_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31539DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "31",
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && spout-design_opt0 && pull-out_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "32",
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && spout-design_opt0 && pull-out_opt1 && finish_opt2"
		],
		"groups": [
			{
				"products": [
					"31454AL1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "33",
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && spout-design_opt0 && pull-out_opt1 && finish_opt3"
		],
		"groups": [
			{
				"products": [
					"31454DL1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "34",
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && spout-design_opt0 && pull-out_opt1 && finish_opt4"
		],
		"groups": [
			{
				"products": [
					"31454KS1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "35",
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && spout-design_opt0 && pull-out_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "36",
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && spout-design_opt1 && pull-out_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31541000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "37",
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && spout-design_opt1 && pull-out_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31541DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "38",
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && spout-design_opt1 && pull-out_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "39",
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && spout-design_opt1 && pull-out_opt1 && finish_opt2"
		],
		"groups": [
			{
				"products": [
					"31455AL1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "40",
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && spout-design_opt1 && pull-out_opt1 && finish_opt3"
		],
		"groups": [
			{
				"products": [
					"31455DL1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "41",
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && spout-design_opt1 && pull-out_opt1 && finish_opt4"
		],
		"groups": [
			{
				"products": [
					"31455KS1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "42",
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && spout-design_opt1 && pull-out_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "43",
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && spout-design_opt2 && pull-out_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31543000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "44",
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && spout-design_opt2 && pull-out_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31543DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "45",
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && spout-design_opt2 && pull-out_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "46",
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && spout-design_opt2 && pull-out_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "47",
		"conditions": [
			"location_opt0 && water-type_opt2 && main-tap_opt0 && spout-design_opt0 && pull-out_opt0"
		],
		"groups": [
			{
				"products": [
					"31539000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "48",
		"conditions": [
			"location_opt0 && water-type_opt2 && main-tap_opt0 && spout-design_opt0 && pull-out_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454001",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "49",
		"conditions": [
			"location_opt0 && water-type_opt2 && main-tap_opt0 && spout-design_opt0 && pull-out_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC1",
					"30339DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "50",
		"conditions": [
			"location_opt0 && water-type_opt2 && main-tap_opt0 && spout-design_opt1 && pull-out_opt0 && boiler-size_opt0"
		],
		"groups": [
			{
				"products": [
					"31541000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "51",
		"conditions": [
			"location_opt0 && water-type_opt2 && main-tap_opt0 && spout-design_opt1 && pull-out_opt0 && boiler-size_opt1"
		],
		"groups": [
			{
				"products": [
					"31541DC0",
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "52",
		"conditions": [
			"location_opt0 && water-type_opt2 && main-tap_opt0 && spout-design_opt1 && pull-out_opt1 && finish_opt0 && boiler-size_opt0"
		],
		"groups": [
			{
				"products": [
					"31455001",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "53",
		"conditions": [
			"location_opt0 && water-type_opt2 && main-tap_opt0 && spout-design_opt1 && pull-out_opt1 && finish_opt3"
		],
		"groups": [
			{
				"products": [
					"31455DL1",
					"30085DL1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "54",
		"conditions": [
			"location_opt0 && water-type_opt2 && main-tap_opt0 && spout-design_opt1 && pull-out_opt1 && finish_opt1 && boiler-size_opt0"
		],
		"groups": [
			{
				"products": [
					"31455DC1",
					"30085DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "55",
		"conditions": [
			"location_opt0 && water-type_opt2 && main-tap_opt0 && spout-design_opt1 && pull-out_opt1 && finish_opt2"
		],
		"groups": [
			{
				"products": [
					"31455AL1",
					"30085AL1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "56",
		"conditions": [
			"location_opt0 && water-type_opt2 && main-tap_opt0 && spout-design_opt1 && pull-out_opt1 && finish_opt0 && boiler-size_opt1"
		],
		"groups": [
			{
				"products": [
					"31455001",
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "57",
		"conditions": [
			"location_opt0 && water-type_opt2 && main-tap_opt0 && spout-design_opt1 && pull-out_opt1 && finish_opt1 && boiler-size_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC1",
					"30080DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "58",
		"conditions": [
			"location_opt0 && water-type_opt2 && main-tap_opt1 && finish_opt0 && boiler-size_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "59",
		"conditions": [
			"location_opt0 && water-type_opt2 && main-tap_opt1 && finish_opt2"
		],
		"groups": [
			{
				"products": [
					"30083AL1",
					"31498AL1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "60",
		"conditions": [
			"location_opt0 && water-type_opt2 && main-tap_opt1 && finish_opt3"
		],
		"groups": [
			{
				"products": [
					"30083DL1",
					"31498DL1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "61",
		"conditions": [
			"location_opt0 && water-type_opt2 && main-tap_opt1 && finish_opt1 && boiler-size_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "62",
		"conditions": [
			"location_opt0 && water-type_opt2 && main-tap_opt1 && finish_opt0 && boiler-size_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "63",
		"conditions": [
			"location_opt0 && water-type_opt2 && main-tap_opt1 && finish_opt1 && boiler-size_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "64",
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && spout-design_opt0"
		],
		"groups": [
			{
				"products": [
					"30399001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "65",
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && spout-design_opt1 && finish_opt0 && boiler-size_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "66",
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && spout-design_opt1 && finish_opt2"
		],
		"groups": [
			{
				"products": [
					"30085AL1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "67",
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && spout-design_opt1 && finish_opt3"
		],
		"groups": [
			{
				"products": [
					"30085DL1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "68",
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && spout-design_opt1 && finish_opt1 && boiler-size_opt0"
		],
		"groups": [
			{
				"products": [
					"30085DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "69",
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && spout-design_opt1 && finish_opt0 && boiler-size_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "70",
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && spout-design_opt1 && finish_opt1 && boiler-size_opt1"
		],
		"groups": [
			{
				"products": [
					"30080DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "71",
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && spout-design_opt0 && finish_opt0 && boiler-size_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "72",
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && spout-design_opt0 && finish_opt2"
		],
		"groups": [
			{
				"products": [
					"30327AL1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "73",
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && spout-design_opt0 && finish_opt3"
		],
		"groups": [
			{
				"products": [
					"30327DL1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "74",
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && spout-design_opt0 && finish_opt4"
		],
		"groups": [
			{
				"products": [
					"30327KS1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "75",
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && spout-design_opt0 && finish_opt1 && boiler-size_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "76",
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && spout-design_opt0 && finish_opt0 && boiler-size_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "77",
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && spout-design_opt0 && finish_opt1 && boiler-size_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "78",
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && spout-design_opt1 && finish_opt0 && boiler-size_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "79",
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && spout-design_opt1 && finish_opt1 && boiler-size_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "80",
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && spout-design_opt1 && finish_opt2"
		],
		"groups": [
			{
				"products": [
					"30083AL1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "81",
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && spout-design_opt1 && finish_opt3"
		],
		"groups": [
			{
				"products": [
					"30083DL1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "82",
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && spout-design_opt1 && finish_opt4"
		],
		"groups": [
			{
				"products": [
					"30083KS1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "83",
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && spout-design_opt1 && finish_opt0 && boiler-size_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "84",
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && spout-design_opt1 && finish_opt1 && boiler-size_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "85",
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "86",
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "87",
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && finish_opt2"
		],
		"groups": [
			{
				"products": [
					"31498AL1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "88",
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && finish_opt3"
		],
		"groups": [
			{
				"products": [
					"31498DL1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "89",
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && spout-design_opt0 && pull-out_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31539000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "90",
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && spout-design_opt0 && pull-out_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31539DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "91",
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && spout-design_opt0 && pull-out_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "92",
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && spout-design_opt0 && pull-out_opt1 && finish_opt2"
		],
		"groups": [
			{
				"products": [
					"31454AL1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "93",
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && spout-design_opt0 && pull-out_opt1 && finish_opt3"
		],
		"groups": [
			{
				"products": [
					"31454DL1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "94",
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && spout-design_opt0 && pull-out_opt1 && finish_opt4"
		],
		"groups": [
			{
				"products": [
					"31454KS1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "95",
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && spout-design_opt0 && pull-out_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "96",
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && spout-design_opt1 && pull-out_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31541000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "97",
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && spout-design_opt1 && pull-out_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31541DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "98",
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && spout-design_opt1 && pull-out_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "99",
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && spout-design_opt1 && pull-out_opt1 && finish_opt2"
		],
		"groups": [
			{
				"products": [
					"31455AL1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "100",
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && spout-design_opt1 && pull-out_opt1 && finish_opt3"
		],
		"groups": [
			{
				"products": [
					"31455DL1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "101",
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && spout-design_opt1 && pull-out_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "102",
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && spout-design_opt2 && pull-out_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31543000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "103",
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && spout-design_opt2 && pull-out_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31543DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "104",
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && spout-design_opt2 && pull-out_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "105",
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && spout-design_opt2 && pull-out_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC1"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "106",
		"conditions": [
			"location_opt1 && water-type_opt2 && main-tap_opt0 && spout-design_opt0 && pull-out_opt0"
		],
		"groups": [
			{
				"products": [
					"31539000",
					"30339001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "107",
		"conditions": [
			"location_opt1 && water-type_opt2 && main-tap_opt0 && spout-design_opt0 && pull-out_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454001",
					"30339001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "108",
		"conditions": [
			"location_opt1 && water-type_opt2 && main-tap_opt0 && spout-design_opt0 && pull-out_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC1",
					"30339DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "109",
		"conditions": [
			"location_opt1 && water-type_opt2 && main-tap_opt0 && spout-design_opt1 && pull-out_opt0 && boiler-size_opt0"
		],
		"groups": [
			{
				"products": [
					"31541000",
					"30085001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "110",
		"conditions": [
			"location_opt1 && water-type_opt2 && main-tap_opt0 && spout-design_opt1 && pull-out_opt0 && boiler-size_opt1"
		],
		"groups": [
			{
				"products": [
					"31541DC0",
					"30080001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "111",
		"conditions": [
			"location_opt1 && water-type_opt2 && main-tap_opt0 && spout-design_opt1 && pull-out_opt1 && finish_opt0 && boiler-size_opt0"
		],
		"groups": [
			{
				"products": [
					"31455001",
					"30085001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "112",
		"conditions": [
			"location_opt1 && water-type_opt2 && main-tap_opt0 && spout-design_opt1 && pull-out_opt1 && finish_opt2"
		],
		"groups": [
			{
				"products": [
					"31455AL1",
					"30085AL1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "113",
		"conditions": [
			"location_opt1 && water-type_opt2 && main-tap_opt0 && spout-design_opt1 && pull-out_opt1 && finish_opt3"
		],
		"groups": [
			{
				"products": [
					"31455DL1",
					"30085DL1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "114",
		"conditions": [
			"location_opt1 && water-type_opt2 && main-tap_opt0 && spout-design_opt1 && pull-out_opt1 && finish_opt1 && boiler-size_opt0"
		],
		"groups": [
			{
				"products": [
					"31455DC1",
					"30085DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "115",
		"conditions": [
			"location_opt1 && water-type_opt2 && main-tap_opt0 && spout-design_opt1 && pull-out_opt1 && finish_opt0 && boiler-size_opt1"
		],
		"groups": [
			{
				"products": [
					"31455001",
					"30080001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "116",
		"conditions": [
			"location_opt1 && water-type_opt2 && main-tap_opt0 && spout-design_opt1 && pull-out_opt1 && finish_opt1 && boiler-size_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC1",
					"30080DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "117",
		"conditions": [
			"location_opt1 && water-type_opt2 && main-tap_opt1 && finish_opt0 && boiler-size_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "118",
		"conditions": [
			"location_opt1 && water-type_opt2 && main-tap_opt1 && finish_opt2"
		],
		"groups": [
			{
				"products": [
					"30083AL1",
					"31498AL1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "119",
		"conditions": [
			"location_opt1 && water-type_opt2 && main-tap_opt1 && finish_opt3"
		],
		"groups": [
			{
				"products": [
					"30083DL1",
					"31498DL1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "120",
		"conditions": [
			"location_opt1 && water-type_opt2 && main-tap_opt1 && finish_opt1 && boiler-size_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "121",
		"conditions": [
			"location_opt1 && water-type_opt2 && main-tap_opt1 && finish_opt0 && boiler-size_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"line": "122",
		"conditions": [
			"location_opt1 && water-type_opt2 && main-tap_opt1 && finish_opt1 && boiler-size_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/water_conditions_de_de.json
// module id = 849
// module chunks = 0